import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { FaCompass, FaHome, FaSearch } from "react-icons/fa";

const PageNotFound = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  return (
    <section
      className={classNames(classes.pnfSection, "pnfSectionCommon py-5")}
    >
      <Container fluid="fluid">
        <Row className="justify-content-center">
          <Col xxl={7} xl={9} lg={11}>
            <div className="pnfInner text-center py-5 position-relative">
              <span className="sing">404</span>
              <Row className="justify-content-center position-relative z-1">
                <Col lg={8}>
                  <div className="pnfIcn ms-auto me-auto">
                    <div className="pnfIRing"></div>
                    <div className="pnfIRing"></div>
                    <div className="pnfIRing"></div>
                    <div className="pnfIBg">
                      <FaCompass
                        style={{ width: 40, height: 40 }}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <h4>This page couldn't be found</h4>
                  <p className="opacity-75">
                    The link you followed may be broken, expired, or this
                    organisation listing may have been removed. Try searching or
                    browse all organisations.
                  </p>
                  <div className="text-center mt-4 pt-2">
                    <ButtonComponent
                      variant="dark"
                      onClick={() => {
                        navigate(`/`);
                      }}
                      title="Browse organisations"
                      style={{ maxWidth: 220 }}
                      className="w-100"
                    >
                      <FaSearch className="me-1" /> Browse organisations
                    </ButtonComponent>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
PageNotFound.propTypes = {
  history: propTypes.object,
};
export default PageNotFound;
